// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"gE-z","smallCardRow":"hE-z","largeCardRow":"iE-z","productSearchRow":"jE-z","curatedRow":"kE-z"};